import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface AppState {
  // 主题设置
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;

  // 语言设置
  language: 'zh' | 'en';
  setLanguage: (language: 'zh' | 'en') => void;

  // 用户信息
  user: {
    id?: string;
    name?: string;
    email?: string;
  } | null;
  setUser: (user: AppState['user']) => void;

  // 全局加载状态
  loading: boolean;
  setLoading: (loading: boolean) => void;

  // 当前编辑的本体信息
  currentOntology: {
    id?: number;
    name?: string;
    canEdit?: boolean;
  } | null;
  setCurrentOntology: (ontology: AppState['currentOntology']) => void;

  // 编辑器是否有未保存的更改
  isEditorDirty: boolean;
  setIsEditorDirty: (dirty: boolean) => void;
}

export const useAppStore = create<AppState>()(
  devtools(
    (set) => ({
      // 初始状态
      theme: 'light',
      language: 'zh',
      user: null,
      loading: false,
      currentOntology: null,
      isEditorDirty: false,

      // Actions
      setTheme: (theme) => set({ theme }, false, 'setTheme'),
      setLanguage: (language) => set({ language }, false, 'setLanguage'),
      setUser: (user) => set({ user }, false, 'setUser'),
      setLoading: (loading) => set({ loading }, false, 'setLoading'),
      setCurrentOntology: (currentOntology) => set({ currentOntology }, false, 'setCurrentOntology'),
      setIsEditorDirty: (isEditorDirty) => set({ isEditorDirty }, false, 'setIsEditorDirty'),
    }),
    {
      name: 'app-store',
    }
  )
);
